<template>
  <div
    v-if="items && items.length"
    class="u-mb-15"
  >
    <h3 class="u-bold">
      {{ title }}:
    </h3>
    <template v-for="({ name }, index) in items">
      <template v-if="index !== 0">
        <span>, </span>
      </template>
      <span
        :key="index"
        :class="itemClass"
        @click="$emit('click:item', name)"
      >{{ name }}</span>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        required: true,
      },
      itemClass: String,
    },
  };
</script>
